<script>
import { fetchAvailabilityData } from '~/queries'

export default defineComponent({
  name: "CheckForAvailabilitiesButton",
  props: {
    criteria: {
      type: Object,
      required: true,
    },
  },
  emits: [
    "onAvailabilityFetchStart",
    "onAvailabilityFetchFinish",
  ],
  setup(props, { emit }) {

    const submitting = ref(false)
    const handleCheckAvailability = async () => {
      emit('onAvailabilityFetchStart')
      const query = {}
      Object.entries(props.criteria.queryParams).forEach(([key, value]) => {
        if (value && value > 0) {
          query[`search[variations][${key}]`] = value
        }
      })

      const data = await fetchAvailabilityData({
        productId: props.criteria.productId,
        performanceId: props.criteria.performanceId,
        date: props.criteria.date?.toISOString().split('T')[0],
        ...query,
      })
      emit('onAvailabilityFetchFinish', data)
    }

    return {
      handleCheckAvailability,
      submitting,
    }
  }
})
</script>

<template>
  <AppButton
    full-width
    class="mt-8"
    :loading="submitting"
    @click="handleCheckAvailability"
  >
    {{ $t('component.tickets.transport.button.get-availability') }}
  </AppButton>
</template>

<style scoped lang="scss">

</style>
